import { Instagram, Linkedin, Twitter, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-pearl border-t border-charcoal/10 pt-16 pb-10"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 pb-12 border-b border-charcoal/10">
          <div className="lg:col-span-5">
            <a
              href="#home"
              className="font-display text-3xl text-charcoal"
              data-testid="footer-logo"
            >
              {/* She Means <span className="italic text-lilac">Content</span> */}
              <img src="/img/logo.png" alt="Logo"  style={{height:"60px"}}/>
            </a>
            <p className="mt-5 text-charcoal/65 max-w-md text-sm leading-relaxed">
              A women-led digital studio building brands that look beautiful,
              speak clearly, and grow with intention.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[0.68rem] uppercase tracking-[0.24em] text-charcoal/55 mb-4">
              Navigate
            </div>
            <ul className="space-y-3 text-sm">
              {["Home", "About", "Service", "Team", "Contact"].map((l) => (
                <li key={l}>
                  <a
                    href={`#${l.toLowerCase() === "service" ? "services" : l.toLowerCase()}`}
                    className="text-charcoal/75 hover:text-lilac transition-colors"
                    data-testid={`footer-link-${l.toLowerCase()}`}
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-[0.68rem] uppercase tracking-[0.24em] text-charcoal/55 mb-4">
              Stay Connected
            </div>
            <p className="text-charcoal/65 text-sm leading-relaxed mb-5">
              Follow our journal for monthly playbooks, case studies and
              industry takes — straight from the studio.
            </p>
            <div className="flex items-center gap-3">
              {[
                { Icon: Instagram, label: "Instagram", href: "#" },
               /*  { Icon: Linkedin, label: "LinkedIn", href: "#" },
                { Icon: Twitter, label: "Twitter", href: "#" }, */
                { Icon: Mail, label: "Email", href: "mailto:hello@shemeanscontent.com" },
              ].map(({ Icon, label, href }) => (
                <a
                  key={label}
                  href={href}
                  aria-label={label}
                  className="w-10 h-10 rounded-full border border-charcoal/15 flex items-center justify-center text-charcoal hover:bg-charcoal hover:text-pearl transition-colors"
                  data-testid={`footer-social-${label.toLowerCase()}`}
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-charcoal/55">
          <div data-testid="footer-copyright">
            © {new Date().getFullYear()} She Means Content. All rights reserved.
          </div>
          <div className="flex items-center gap-6 uppercase tracking-[0.2em]">
            <a href="#" className="hover:text-lilac transition-colors">
              Privacy
            </a>
            <a href="#" className="hover:text-lilac transition-colors">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
